import * as React from 'react';
const h = React.createElement;

export interface MenuItemProps {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  // Injected by Menu via cloneElement
  _selected?: boolean;
  _onClick?: () => void;
}

export interface MenuProps {
  mode?: 'vertical' | 'horizontal' | 'inline';
  selectedKeys?: React.Key[];
  onClick?: (info: { key: React.Key; item: React.ReactElement }) => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

interface MenuComponent extends React.FC<MenuProps> {
  Item: React.FC<MenuItemProps>;
}

const MenuBase: React.FC<MenuProps> = function Menu(props) {
  const { mode = 'vertical', selectedKeys = [], onClick, children, style, className = '' } = props;
  return h(
    'div',
    {
      className: `bg-dark-900 ${mode === 'inline' ? 'py-1' : 'flex items-center'} ${className}`,
      style: style || {},
    },
    React.Children.map(children, (child) => {
      if (!React.isValidElement(child) || child.type !== (Menu as unknown as MenuComponent).Item)
        return child;
      const isSelected = child.key != null && selectedKeys.includes(child.key);
      return React.cloneElement(child as React.ReactElement<MenuItemProps>, {
        _selected: isSelected,
        _onClick: () => {
          if (onClick && child.key != null)
            onClick({ key: child.key, item: child as React.ReactElement });
        },
      });
    }),
  );
};

const Menu = MenuBase as MenuComponent;

Menu.Item = function MenuItem(props) {
  const { icon, children, _selected, _onClick, className = '' } = props;
  return h(
    'div',
    {
      className: `flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors text-sm ${_selected ? 'bg-primary-600/15 text-primary-400 border-r-2 border-primary-500' : 'text-dark-300 hover:bg-dark-800 hover:text-white'} ${className}`,
      onClick: _onClick,
    },
    icon && h('span', { className: 'text-base' }, icon),
    children,
  );
};

export { Menu };
